import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormLabel,
  IconButton,
  Button,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';

function ProviderConsultOptionInsert(props) {
  const {
    provider,
    open,
    onClose,
    updateProviderInfo,
    classes: {
      modal,
      modalContent,
      contentCard,
      input,
      innerPadding,
      fontAdjust,
    },
  } = props;

  const [preferredAge, setPreferredAge] = useState(provider.preferredAge || '');
  const [preferredGender, setPreferredGender] = useState(
    provider.preferredGender || ''
  );

  const updateProvider = () => {
    updateProviderInfo({
      providerId: provider.id,
      preferredAge,
      preferredGender,
    });
  };

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;

    if (open) {
      html.style.overflow = 'hidden';
      body.style.overflow = 'hidden';
    } else {
      html.style.overflow = '';
      body.style.overflow = '';
    }

    return () => {
      html.style.overflow = '';
      body.style.overflow = '';
    };
  }, [open]);

  return (
    <Dialog fullWidth open={open} onClose={onClose} className="modal-sm">
      <DialogTitle>
        <Grid container alignItems="center">
          <Grid item xs={11} className="headingSize">
            <h2>Edit content</h2>
          </Grid>
          <Grid item xs={1}>
            <IconButton aria-label="Close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent classes={{ root: modalContent }}>
        <div>
          <FormControl component="fieldset" variant="filled" className={input}>
            <FormLabel component="legend">
              1) Choose Preferred Patient Age for booking appointment
            </FormLabel>
            <RadioGroup
              row
              aria-label="Preferred Patient Age"
              name="preferredAge"
              value={preferredAge}
              onChange={event => {
                setPreferredAge(event.target.value);
              }}
            >
              <FormControlLabel value="all" control={<Radio />} label="All" />
              <FormControlLabel
                value="below_18"
                control={<Radio />}
                label="Below 18+"
              />
              <FormControlLabel
                value="above_18"
                control={<Radio />}
                label="Above 18+"
              />
            </RadioGroup>
          </FormControl>
        </div>
        <div>
          <FormControl component="fieldset" variant="filled" className={input}>
            <FormLabel component="legend">
              2) Choose Preferred Patient Gender for booking appointment
            </FormLabel>
            <RadioGroup
              row
              aria-label="Preferred Patient Gender"
              name="preferredGender"
              value={preferredGender}
              onChange={event => {
                setPreferredGender(event.target.value);
              }}
            >
              <FormControlLabel value="all" control={<Radio />} label="All" />
              <FormControlLabel
                value="female"
                control={<Radio />}
                label="Female"
              />
              <FormControlLabel value="male" control={<Radio />} label="Male" />
            </RadioGroup>
          </FormControl>
        </div>
        <Button
          color="primary"
          variant="contained"
          justify="center"
          onClick={updateProvider}
          disabledDuringOnClick={true}
          style={{ width: 'fit-content', margin: 'auto' }}
        >
          Save
        </Button>
      </DialogContent>
    </Dialog>
  );
}

const styles = () => ({
  modalContent: {
    overflow: 'visible',
    display: 'flex',
    flexDirection: 'column',
  },
  actions: {
    marginTop: '1em',
  },
  input: {
    margin: '0.5em 0',
  },
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
  contentCard: {
    margin: '1.5em',
    display: 'flex',
    justify: 'center',
  },
  innerPadding: {
    padding: '1.5em',
    display: 'flex',
    justify: 'center',
  },
  selectFormatting: {
    background: 'white',
  },
  fontAdjust: {
    padding: '1.5em 0 0 0 ',
  },
});

export default withStyles(styles)(ProviderConsultOptionInsert);
